import type { SiteArrivalConfirmationFormValues, SiteArrivalConfirmationStep } from './siteArrivalConfirmationTypes';

export function isYes(raw: string): boolean {
  const v = raw.trim().toLowerCase();
  return v === 'yes' || v === 'true';
}

export function formatYesNo(t: (k: string) => string, raw: string): string {
  return isYes(raw)
    ? t('submitDocuments.siteArrivalConfirmation.yes')
    : t('submitDocuments.siteArrivalConfirmation.no');
}

export function formatUseYesNo(t: (k: string) => string, raw: string): string {
  return isYes(raw)
    ? t('submitDocuments.siteArrivalConfirmation.useYes')
    : t('submitDocuments.siteArrivalConfirmation.useNo');
}

export function formatAgree(t: (k: string) => string, raw: string): string {
  return isYes(raw) ? t('submitDocuments.siteArrivalConfirmation.agreeCheckbox') : '';
}

export function formatIsoDate(raw: string): string {
  const m = raw.trim().match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (!m) return raw.trim();
  return `${m[1]}/${Number(m[2])}/${Number(m[3])}`;
}

export function formatCommitted(
  stepId: SiteArrivalConfirmationStep,
  t: (k: string) => string,
  raw: string,
  values: SiteArrivalConfirmationFormValues
): string {
  if (stepId === 'healthCheckupDate') return formatIsoDate(raw);
  if (stepId === 'healthCheckupLocation' || stepId === 'rentOther') return raw.trim();
  if (stepId === 'agreeDorm' || stepId === 'agreeMeal') return formatAgree(t, raw);
  if (
    stepId === 'rentTv' ||
    stepId === 'rentFutons' ||
    stepId === 'rentFridge' ||
    stepId === 'breakfast' ||
    stepId === 'lunch' ||
    stepId === 'dinner'
  ) {
    return formatUseYesNo(t, raw);
  }
  if (stepId === 'companyAccommodation') {
    return isYes(raw)
      ? t('submitDocuments.siteArrivalConfirmation.accommodationYes')
      : t('submitDocuments.siteArrivalConfirmation.accommodationNo');
  }
  if (stepId === 'travelReceiptAcknowledged') return formatYesNo(t, raw);
  return raw.trim();
}
